export default "__VITE_ASSET__892fd03d__"